export class CsvOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "hasHeader",
            "baseName": "hasHeader",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "delimiter",
            "baseName": "delimiter",
            "type": "string",
            "format": ""
        },
        {
            "name": "quote",
            "baseName": "quote",
            "type": "string",
            "format": ""
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CsvOptions.attributeTypeMap;
    }
    constructor() {
    }
}
